import { useState } from 'react'
import { PrescriptionList } from './PrescriptionList'
import { PrescriptionBuilder } from './PrescriptionBuilder'
import { Prescription } from '../types/prescription'
import { Patient } from '../types/patient'

interface PrescriptionsTabContentProps {
  patientId: string
  patient?: Patient
  readOnly?: boolean
}

export function PrescriptionsTabContent({ patientId, patient, readOnly = false }: PrescriptionsTabContentProps) {
  const [showBuilder, setShowBuilder] = useState(false)
  const [editingPrescription, setEditingPrescription] = useState<Prescription | undefined>()
  const canWrite = !readOnly

  const handleNewPrescription = () => {
    if (!canWrite) return
    setEditingPrescription(undefined)
    setShowBuilder(true)
  }

  const handleEditPrescription = (prescription: Prescription) => {
    if (!canWrite) return
    setEditingPrescription(prescription)
    setShowBuilder(true)
  }

  const handleSavePrescription = () => {
    setShowBuilder(false)
    setEditingPrescription(undefined)
  }

  const handleCancelPrescription = () => {
    setShowBuilder(false)
    setEditingPrescription(undefined)
  }

  if (showBuilder && canWrite) {
    return (
      <PrescriptionBuilder
        patientId={patientId}
        patient={patient}
        prescription={editingPrescription}
        onSave={handleSavePrescription}
        onCancel={handleCancelPrescription}
      />
    )
  }

  return (
    <PrescriptionList
      patientId={patientId}
      onNewPrescription={handleNewPrescription}
      onEditPrescription={handleEditPrescription}
      readOnly={!canWrite}
    />
  )
}

